
















































import _ from 'lodash'
import moment from 'moment'
import { DataTablePagination } from '@/types/_'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import ModalRegraDeCalculoIncluirProcedimentoDescartar from './ModalRegraDeCalculoIncluirProcedimentoDescartar.vue'

@Component({
  components: {
    ModalRegraDeCalculoIncluirProcedimentoDescartar,
  },
})
export default class ProcedimentosDescartarDataTable extends Vue {
  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  loadProcedimentosDescartar: boolean = false
  get loadingProcedimentosDescartar() { return this.loadProcedimentosDescartar }
  set loadingProcedimentosDescartar(value: boolean) { this.loadProcedimentosDescartar = value }

  get regraDeCalculoProcedimentosDescartarHeaders() {
    return [
      { text: 'Código', value: 'codigoProcedimento', sortable: false },
      { text: 'Descrição', value: 'descricaoProcedimento', sortable: false },
      { text: 'Incluído por', value: 'createdByNome', sortable: false },
      { text: 'Incluído em', value: 'createdOn', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get regraDeCalculoProcedimentosDescartar() { return this.getRegrasDeCalculoStore.regraDeCalculoProcedimentosDescartar }
  get paginacaoProcedimentosDescartar() { return this.getRegrasDeCalculoStore.paginacaoProcedimentosDescartar }
  procedimentosDescartarDebounced = _.debounce(param => this.getRegrasDeCalculoStore.getRegraCalculoProcedimentoDescartarAll(param), 700)

  async updatePaginationProcedimentosDescartar(pagination: DataTablePagination) {
    if (!this.getRegrasDeCalculoStore.modal.regraDeCalculo) return
    this.loadingProcedimentosDescartar = true
    this.procedimentosDescartarDebounced(pagination)
    this.loadingProcedimentosDescartar = false
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  loadDeletarRegraDeCalculoProcedimentosDescartar: string = ''
  get loadingDeletarRegraDeCalculoProcedimentosDescartar() { return this.loadDeletarRegraDeCalculoProcedimentosDescartar }
  set loadingDeletarRegraDeCalculoProcedimentosDescartar(value: string) { this.loadDeletarRegraDeCalculoProcedimentosDescartar = value }

  get showModalAddRegraCalculoProcedimentosDescartar() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoProcedimentosDescartar }
  set showModalAddRegraCalculoProcedimentosDescartar(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoProcedimentosDescartar', value }) }

  async removeRegraCalculoProcedimentoDescartar(procedimentoDescartarId: string) {
    this.loadingDeletarRegraDeCalculoProcedimentosDescartar = procedimentoDescartarId
    const request = await this.getRegrasDeCalculoStore.removeRegraCalculoProcedimentoDescartar(procedimentoDescartarId)
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingDeletarRegraDeCalculoProcedimentosDescartar = ''
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento apagado com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingDeletarRegraDeCalculoProcedimentosDescartar = ''
  }
}
